module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_5012.7dc10d13.png";